import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');
      const storedType = localStorage.getItem('userType');
      
      if (storedToken && storedUser) {
        setToken(storedToken);
        setUser({ ...JSON.parse(storedUser), type: storedType });
        axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
      }
      setIsLoading(false);
    };
    
    initAuth();
  }, []);

  const loginCustomer = async (email, password) => {
    const response = await axios.post(`${API_URL}/auth/customer/login`, { email, password });
    
    // Check if requires selection
    if (response.data.requires_selection) {
      return response.data; // Return selection data to component
    }
    
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userType', 'customer');
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser({ ...userData, type: 'customer' });
    
    return response.data;
  };

  const loginCustomerById = async (customerId, password) => {
    const response = await axios.post(`${API_URL}/auth/customer/login-by-id`, { 
      customer_id: customerId, 
      password 
    });
    
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userType', 'customer');
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser({ ...userData, type: 'customer' });
    
    return response.data;
  };

  const registerCustomer = async (data) => {
    const response = await axios.post(`${API_URL}/auth/customer/register`, data);
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userType', 'customer');
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser({ ...userData, type: 'customer' });
    
    return response.data;
  };

  const loginShop = async (email, password) => {
    const response = await axios.post(`${API_URL}/auth/shop/login`, { email, password });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userType', 'shop');
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser({ ...userData, type: 'shop' });
    
    return response.data;
  };

  const registerShop = async (data) => {
    const response = await axios.post(`${API_URL}/auth/shop/register`, data);
    return response.data;
  };

  const verifyShop = async (email, codice) => {
    const response = await axios.post(`${API_URL}/auth/shop/verify`, { email, codice });
    const { token: newToken, user: userData } = response.data;
    
    localStorage.setItem('token', newToken);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('userType', 'shop');
    
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
    setUser({ ...userData, type: 'shop' });
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('userType');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      token,
      isLoading,
      loginCustomer,
      loginCustomerById,
      registerCustomer,
      loginShop,
      registerShop,
      verifyShop,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
